import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import swal from 'sweetalert';
import {Table} from 'react-bootstrap';
import Help from '../../generics/help';

import SvgIcon from 'react-icons-kit';
import {user} from 'react-icons-kit/icomoon/user';
import {phone} from 'react-icons-kit/entypo/phone';
import {plus} from 'react-icons-kit/icomoon/plus';
import {lab} from 'react-icons-kit/icomoon/lab';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import {fileEmpty} from 'react-icons-kit/icomoon/fileEmpty';
import {print} from 'react-icons-kit/fa/print';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

import GeneralModal from './general_modal';

var Config = require('../../../config');

class EpidemiologicalMonitoring extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.getList = this.getList.bind(this);
		this.donorSearch = this.donorSearch.bind(this);
		this.openModal = this.openModal.bind(this);
		this.print = this.print.bind(this);
		this.filtering = this.filtering.bind(this);
		this.addDonor = this.addDonor.bind(this);
		this.donationSelected = this.donationSelected.bind(this);

		this.state ={
			donationSelected: null,
			status:"all",
			status_list:[
				{value:'all', name:'Todos'},
				{value:'sin contactar', name:'Sin Contactar'},
				{value:'contactado', name:'Contactado'},
				{value:'localizado', name:'Localizado'},
				{value:'no se ha presentado', name:'No se ha Presentado'},
				{value:'con consulta medica', name:'Con Consulta Médica'},
				{value:'segunda muestra registrada', name:'Segunda Muestra Registrada'},
				{value:'segunda muestra con resultado', name:'Segunda Muestra con Resultado'},
				{value:'expediente cerrado', name:'Expediente Cerrado'},
			],
			list:[],
			user: JSON.parse(sessionStorage.getItem("medical_staff")),
			is_doctor:false,
			filter:"",
			optionsDonor:[],	    	
			isLoading: false,
			disable_donor:true,
			disable_call:true,
			disable_lab:true,
			disable_hc:true,
			disable_sample:true,
			disable_note:true,
			disable_doc:true
		}
	}

	componentDidMount(){
		var task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));
		task.map((t)=>
			t.type === 'EPIDEMI_DONOR_DATA' ?
				this.setState({disable_donor: false})
			: t.type === 'EPIDEMI_CALLS' ?
				this.setState({disable_call: false})
			: t.type === 'EPIDEMI_LABORATORY' ?
				this.setState({disable_lab: false})
			: t.type === 'EPIDEMI_INTERVIEW' ?
				this.setState({disable_hc: false})
			: t.type === 'EPIDEMI_SECOND_SAMPLE' ?
				this.setState({disable_sample: false})
			: t.type === 'EPIDEMI_NOTES' ?
				this.setState({disable_note: false})
			: t.type === 'EPIDEMI_DOCUMENT' ?
				this.setState({disable_doc: false})
			: null
		);


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

	

		fetch(Config.default.apiGateway.URL+'users/is_doctor',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({is_doctor:response});	
				this.getList('all');
			}
			
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
		if(e.target.name === 'status'){
			this.getList(e.target.value);
		}
	}

	getList(status){

		if(this.isValidForm()){
			this.props.waiting.handleShow('Cargando...');

			fetch(Config.default.apiGateway.URL+'epidemiological_monitoring/?status='+status+
				'&hf_id='+sessionStorage.getItem('health_facilities_id'),{
				method:'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({list:response});
				}
			});
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const select = document.querySelector('div.form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
	}

	donorSearch(e, id){
		e.preventDefault();
		this.props.history.push({
			pathname: '/search_donor/'+id,
			state: { 
			    from: '/epidemiological_monitoring',
			    start: this.state.start_date,
			    end: this.state.end_date
			}
		});
	}

	openModal(e, screen, obj){
		e.preventDefault();

		this.modal_general.handleShow(screen, obj);
	}

	openHC(e, offersId, donorId, monitoringId){
		e.preventDefault();
		this.props.history.push("/interview/clinic_history/"+offersId+"/"+donorId+"/"+monitoringId);
	}

	laboratory(e, sampleId, donationId){
		e.preventDefault();
		this.props.history.push("/results_donation/edit/"+sampleId+"/"+donationId+"/0/");
	}

	secondSample(e, sample_id, donor_id){
		e.preventDefault();

		if(sample_id === 0){
			this.props.history.push('/second_samples/edit/'+sample_id+'/'+donor_id);	
		}else{
			this.props.history.push('/second_samples/edit/'+sample_id);
		}
	}

	async print(e, id){
		e.preventDefault();
		
		this.props.waiting.handleShow('Imprimiendo...');
			
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = "epidemi_monitoring";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({ show: false});
		}else{
			this.props.waiting.handleClose();
		}
	}

	directPrint(response){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = () =>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"clinic_history", "File": "'+aux[1]+'"}');
		}
	}

	filtering(row){
		var string = row.donor_name +' ';

		row.test.map((r, j)=>(
			string += r+(row.test.length - 1 === j ? '' : ' ')
		))

		var valid = true;
		
		if(this.state.filter !== ""){
			if(string.toUpperCase().indexOf(this.state.filter.toUpperCase()) !== -1){
				valid = true;
			}else{
				valid = false;
			}	
		}
		
		return valid;
	}

	_handleSearchDonor = (query) => {
	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'donations/without-monitoring?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var donations = response.donations;
			if(donations !== null){
				for (var i = 0; i < donations.length; i++) {
					donations[i].names = donations[i].donor_name + " - "+donations[i].donation_number;
					donations[i].id = donations[i].donor_id;
				};
				
				this.setState({
					isLoading: false,
			      	optionsDonor: donations
			    });
			}
		})
	}

	donationSelected(values) {
		if(values.length > 0){
			this.setState({donationSelected: values[0]});
		}
	}

	addDonor()
	{
		if(this.state.donationSelected === null){
			swal('Error', "Debe seleccionar un donador", 'error');
			return;
		}
		console.log(this.state.donationSelected);
		var obj = obj = {
			person_id: this.state.donationSelected.person_id, //Id de la persona (donador)
			monitoring: {
				donation_id: this.state.donationSelected.donation_id,
				call_status: "",
				reminder : "",
				monitoring_traceability:[{
					process:'CALL',
					medical_staff_id: this.state.user.id,
					comments: ""
				}]
			},
			phones:[]
		};
		this.props.waiting.handleShow();


		fetch(Config.default.apiGateway.URL+"epidemiological_monitoring",{
			method: "post",
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then((res)=> {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then((response)=>{
			if(response !== undefined){
				this.setState({donationSelected:null, donations:[], optionsDonor:[]});
				this._typeahead.getInstance().clear();
				this.getList("all");
			}
		})
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
        		<div className="route">
          			<h5 className="title_page" >
			            {sessionStorage.getItem('health_facilities_name')} ->
			            {t('sidebar.nav.laboratory.MAIN')} -> 
			            Seguimiento Epidemiológico
          			</h5>
        		</div>
        
        		<Help 
          			{...this.props}
            		menu={"help_laboratory"} 
            		submenu={"help_results_samples"}  />

        		<div className="col-xs-12">
					<div className="col-xs-12 form-group">
						<div className="col-xs-6" style={{paddingTop:"10px"}}>
							<AsyncTypeahead
							labelKey={(option) => `${option.names}`}
							minLength={3}
							maxLength={50}
							name="donor"
							id="donor"
							onSearch={this._handleSearchDonor}
							placeholder="Buscar por apellidos más nombre o número de donacion..."
							options={this.state.optionsDonor}
							onChange={this.donationSelected}
							ref={ref => this._typeahead = ref}
							useCache={false}
							isLoading={this.state.isLoading}
							delay={600}
							paginationText="Mostrar mas resultados..."
							
							/>
						</div>
						<div className="col-xs-2">
							<FloatingActionButton className="action-btn" mini={true} style={{marginLeft: 5 }} 
								onClick={this.addDonor}>
								<ContentAdd/>
							</FloatingActionButton> 
						</div>
					</div>
					
        			<div className="col-xs-12 form form-group">
        				<div className="col-xs-12 col-sm-2">
        					<span className="span-min"></span>
        					<select name="status" id="status" value={this.state.status} 
        						className="form-control" onChange={this.handleChange}>
        						{this.state.status_list.map((s, i)=>(
        							<option key={i} value={s.value}>{s.name}</option>
        						))}
        					</select>
        				</div>
						<div className="col-xs-12 col-sm-4">
        					<span className="span-min"></span>
        					<input type="text" name="filter" id="filter" value={this.state.filter} 
        					 	className="form-control" onChange={this.handleChange} placeholder="Búsqueda" />
        				</div>
        			</div>
        			<div className="col-xs-12">
        				<Table responsive hover>
        					<thead>
        						<tr>
        							<th>Donador</th>
									<th>No. Donación</th>
        							<th>F. Donación</th>
        							<th>Reactividad</th>
        							<th>Datos Donador</th>
        							<th>Llamadas</th>
									<th>Laboratorio</th>
        							<th>H. Clínica</th>
        							<th>2da. Muestra</th>
        							<th>Notas</th>
        							<th>Informe</th>
        							<th>Estatus</th>
        						</tr>
        					</thead>
        					<tbody>
        						{this.state.list.map((list, i)=>(
        							this.filtering(list) &&
	        							<tr key={i}>
	        								<td style={{width:"230px"}}>{list.donor_name}</td>
											<td>{list.reactiveDonationNumber}</td>
	        								<td>{moment(list.donation_date).format('DD/MM/YYYY')}</td>
	        								<td style={{width:"120px"}}>
	        									{list.test.map((r, j)=>(
	        										r+(list.test.length - 1 === j ? '' : ', ')
	        									))}
	        								</td>
	        								<td style={{textAlign:"center"}}>
	        									<a href="#" title="Buscar Donador" style={this.state.disable_donor ? {color:'#b8b8b8', cursor:'no-drop'} : {color:'#333'}}
	        										onClick={(e)=>this.state.disable_donor ? e.preventDefault() : this.donorSearch(e, list.donor_id)}>
	        										<SvgIcon size={20} icon={user} />
	        									</a>
	        								</td>
	        								<td style={{textAlign:"center"}}>
	        									<a href="#" title="Datos Donador">
	        										<SvgIcon size={20} icon={phone} 
	        											style={this.state.disable_call ? {color:'#b8b8b8', cursor:'no-drop'}
															: list.monitoring === null ? {color:'#b8b8b8'} :
	        												list.call ? {color:"var(--color-data)"} : {color:"var(--color-partial-data)"}}
	        											onClick={(e)=>this.state.disable_call ? e.preventDefault() : this.openModal(e, 'seguimiento', {id:list.donation_id, process:'CALL'})}/>
	        									</a>
	        								</td>
											<td style={{textAlign:"center"}}>
	        									<a href="#" title="Laboratorio" style={this.state.disable_lab ? {color:'#b8b8b8', cursor:'no-drop'} : {color:'#333'}}
	        										onClick={(e)=>this.state.disable_lab ? e.preventDefault() : this.laboratory(e, list.reactiveSampleId, list.donation_id)}>
	        										<SvgIcon size={20} icon={lab}  />
	        									</a>
	        								</td>
	        								<td style={{textAlign:"center"}}>
	        									<a href="#" title="Médico Entrevista" 
													onClick={(e)=>
														this.state.disable_hc ? e.preventDefault() :
															(list.call && list.status !== "") ?
																this.state.is_doctor ? this.openHC(e, list.offersId, list.donor_id, list.monitoring.id) : e.preventDefault()
															: e.preventDefault()
													}  
	        										style={
														(list.call  && list.status !== "") ?
															this.state.disable_hc ? {color:'#b8b8b8', cursor:'no-drop'} :
																!this.state.is_doctor ? {cursor:'no-drop', color:'#b8b8b8'} : 
																	list.monitoring === null ? {color:'#b8b8b8'} :
																		list.interview ? {color:"var(--color-data)"} : {color:"var(--color-partial-data)"}
														:{cursor:'no-drop', color:'#b8b8b8'}
													}>
	        										<SvgIcon size={20} icon={plus} />
	        									</a>
	        								</td>
	        								<td style={{textAlign:"center"}}>
	        									<a href="#" title="Laboratorio - Segunda Muestra" 
	        										onClick={(e)=>{this.state.disable_sample ? e.preventDefault() :
														list.interview ?
															this.secondSample(e, list.donors_second_sample_id, list.donor_id)
														: e.preventDefault()
														}}>
	        										<SvgIcon size={20} icon={clipboard} 
	        											style={this.state.disable_sample ? {cursor:'no-drop', color:'#b8b8b8'} : 
															!list.interview?{cursor:'no-drop', color:'#b8b8b8'} 
															:list.donors_second_sample_id !== 0 ? {color:"var(--color-data)"} 
															: {color:"var(--color-partial-data)"}} />
	        									</a>
	        								</td>
	        								<td style={{textAlign:"center"}}>
	        									<a href="#" title="Notas"
													onClick={(e)=>this.state.disable_note ? e.preventDefault() :
															this.state.is_doctor ? this.openModal(e, 'personal', {id:list.donation_id, process:'END'}) : e.preventDefault()
													}>
	        										<SvgIcon size={20} icon={fileEmpty} 
	        											style={this.state.disable_note ? {cursor:'no-drop', color:'#b8b8b8'} :
															(list.monitoring === null || list.status === "") ? {color:'#b8b8b8'} :
															list.end ? {color:"var(--color-data)"} : {color:"var(--color-partial-data)"}
															
														} 
													/>
	        									</a>
	        								</td>
	        								<td style={{textAlign:"center"}}>
	        									<a href="#" title="Imprimir" style={this.state.disable_doc ? {cursor:'no-drop', color:'#b8b8b8'} : {color: '#333'}}
	        										onClick={(e)=>this.state.disable_doc ? e.preventDefault() : this.print(e, list.donation_id)}  >
	        										<SvgIcon size={20} icon={print}  />
	        									</a>
	        								</td>
	        								<td style={{width:"120px"}}>{list.status}</td>
	        							</tr>
        						))}
        					</tbody>
        				</Table>
        			</div>

        		</div>

        		<GeneralModal {...this.props} onRef={ref => this.modal_general = ref} getList={this.getList} />
        	</div>
		);
	}
}

export default translate('translations')(EpidemiologicalMonitoring);